import React from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import Layout from "../Pages/Template/Layout";
import Login from "../Pages/Authentication/Login/Login";
import Resident from "../Pages/Portal/Views/Resident";
import Prospect from "../Pages/Portal/Views/Prospect";
import Owner from "../Pages/Portal/Views/Owner";
import Vendor from "../Pages/Portal/Views/Vendor";
import Application from "./../Pages/Portal/Views/Application";
import Payment from "./../Pages/Portal/Views/Payment";
import SetNewPassword from "../Pages/Authentication/PasswordChanges/SetNewPassword";
import SetUserNewPassword from "../Pages/Authentication/PasswordChanges/SetUserNewPassword";
import Home from "../Pages/Portal/Views/Home";
import UserSetting from "../Pages/Portal/Views/UserSettings/UserSetting";
import ProtectedRoute from './ProtectedRoute';
import PastResident from "../Pages/Portal/Views/PastResident";
import Support from "../Pages/Portal/Views/Support";
import NotFoundPage from "../Pages/Authentication/NotFoundPage";
import ApplicationVault from "../Pages/Portal/Views/ApplicationVault";
import User from '../Pages/Portal/Views/Administrator/User';
import Messages from '../Pages/Portal/Views/Administrator/Messages';
import UserUpload from "../Pages/Portal/Views/UserUpload";

export default function Index() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/login" element={<Login />} />
                <Route path="resetPassword/:passwordChangeId?" element={<SetNewPassword />} />
                <Route path="/resetUserPassword/:customer?/:passwordChangeId?" element={<SetUserNewPassword />} />
                <Route path="/notfound" element={<NotFoundPage />} />

                {/* The parent route for portal-related pages, rendering the Layout component */}
                <Route  element={<Layout><Outlet /></Layout>}>
                    <Route path="/portal">
                        {/* Routes for portal views, all wrapped with ProtectedRoute */}
                        <Route path="home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
                        <Route path="resident" element={<ProtectedRoute><Resident /></ProtectedRoute>} />
                        <Route path="prospect" element={<ProtectedRoute><Prospect /></ProtectedRoute>} />
                        <Route path="owner" element={<ProtectedRoute><Owner /></ProtectedRoute>} />
                        <Route path="vendor" element={<ProtectedRoute><Vendor /></ProtectedRoute>} />
                        <Route path="application" element={<ProtectedRoute><Application /></ProtectedRoute>} />
                        <Route path="payment" element={<ProtectedRoute><Payment /></ProtectedRoute>} />
                        <Route path="pastresident" element={<ProtectedRoute><PastResident /></ProtectedRoute>} />
                        <Route path="support" element={<ProtectedRoute><Support /></ProtectedRoute>} />
                        <Route path="document/vault" element={<ProtectedRoute><ApplicationVault /></ProtectedRoute>} />
                        <Route path="document/userupload" element={<ProtectedRoute><UserUpload /></ProtectedRoute>} />
                    </Route>

                    <Route path="/user">
                        <Route path="settings" element={<ProtectedRoute><UserSetting /></ProtectedRoute>} />
                    </Route>
                    <Route path="/administrator">
                        <Route path="messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
                        <Route path="users" element={<ProtectedRoute><User /></ProtectedRoute>} />
                    </Route>
                </Route>

                <Route path="*" element={<Login />} />
            </Routes>
        </BrowserRouter>
    );
}
